module.exports = __webpack_public_path__ + "img/jcb.d79c34e5.png";